// @flow
import React from 'react';
import { openSupportWhatsApp, SUPPORT_ERROR_WHATSAPP_URL } from '../../../helpers/appRecovery';
import './ErrorBoundaryView.scss';

type Props = {
  // A try is on its way (also when it's slow): "Tentar de novo" waits for it
  trying: boolean,
  onRetry: () => void,
  onSignOut: () => void,
};

// The first start of a new version couldn't reach the API for the user and the clinics (no internet, a
// dropped or very slow connection, the API failing). Nothing was lost: the login and the stored data stay,
// and app.js tries again by itself. "Sair e entrar de novo" is the way out when it never gets through.
// Plain elements and fixed Portuguese text, like CrashScreen.
const StartUnreachable = ({ trying, onRetry, onSignOut }: Props) => (
  <div id="startUnreachable" className="crashScreen" role="alert">
    <h1>Não conseguimos falar com o Doutore</h1>
    <p className="crashScreen-text">
      Pode ser a internet deste aparelho ou o nosso servidor. Você continua conectado à sua conta, e o Doutore
      abre sozinho assim que conseguir.
    </p>
    <button type="button" className="crashScreen-reload" onClick={onRetry} disabled={trying}>
      {trying ? 'Tentando…' : 'Tentar de novo'}
    </button>
    <button type="button" className="crashScreen-secondary" onClick={onSignOut}>
      Sair e entrar de novo
    </button>
    <a
      className="crashScreen-support"
      href={SUPPORT_ERROR_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={openSupportWhatsApp}
    >
      Falar com o suporte
    </a>
  </div>
);

export default StartUnreachable;
